"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.space = void 0;
var space = {
  margin: [],
  'margin-bottom': [10, 12, 14]
};
exports.space = space;